// extracted by mini-css-extract-plugin
module.exports = {"adsBlock":"AgreementsBlock_adsBlock__1K9Q7","container":"AgreementsBlock_container__EAuon","policyBlock":"AgreementsBlock_policyBlock__Ybhgz"};